export default __webpack_public_path__ + "static/media/IMG_2136.031c78bc.JPG";